import React, { useState } from 'react';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import useModal from 'hooks/useModal';
import CancelRegistrationModal from 'components/cancelRegistrationModal/CancelRegistrationModal';
import crossBtn from "assets/images/CancelDuty.svg";

const CommonTableDialog = (props) => {
  const { open, setOpen, vipStatus, menuData } = props;
  const { open: visible, toggle: setVisible } = useModal();

  const [vip, setVip] = useState(vipStatus);
  const openDialog = Boolean(open);

  const handleClick = (value) => {
     if (value.key === "cancelDuty") {
      props?.setOpen(false);
      setVisible();
    }
  };

  const handleClose = () => {
    setOpen(null);
  };

  const moreIconSrc = (value) => {
    switch (value?.toLowerCase()) {
      case "cancel":
        return crossBtn;
      default:
        return "";
    }
  };

  return (
    <Grid
      container
      className="commonFilter widthFit"
      alignItems={'center'}
      role="presentation"
    >
      <Menu
        id="basic-menu"
        anchorEl={open}
        open={openDialog}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {menuData &&
          menuData.map((menu, index) => (
            <MenuItem
              onClick={() => handleClick(menu)}
              key={index}
            >
              {/* TODO: commented this fetaure due to there is no access for company frontdesk to make as VIP */}
              {/* {menu.label === 'Vip' && (
                <FormControlLabel
                  sx={{
                    marginLeft: '0px',
                    span: {
                      padding: '0px 5px 0px 0px',
                      svg: { width: '20px', height: '20px' },
                    },
                  }}
                  control={<Checkbox name="Vip" value={vip} />}
                  label={
                    <Typography variant="body3" className="colorPrimary">
                      {menu.label === 'Vip' && menu.label}
                    </Typography>
                  }
                />
              )} */}

              {moreIconSrc(menu?.label)?.length > 0 && (
                <span className="mr10 alignItem flexDisplay width20">
                  <img
                    src={moreIconSrc(menu?.label)}
                    alt={menu?.label}
                    className="width20"
                  />
                </span>
              )}
              <Typography
                variant="body3"
                className="fw500"
              >
                {menu.label}
              </Typography>
            </MenuItem>
          ))}
      </Menu>

      {visible && <CancelRegistrationModal
        pageType={"bookingDetails"}
        open={visible}
        toggle={setVisible}
        reservationData={props?.data}
      />}
    </Grid>
  );
};

export default CommonTableDialog;
